module.exports = __webpack_public_path__ + "static/media/2.bcd26e4c.png";